export const checklogin = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (userData) {
    return true;
  } else {
    return false;
  }
};
